import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { AlertCircle } from 'lucide-react';
import api from '@/lib/api';

/**
 * Top-bar badge surfacing records flagged `needs_review=true` by DataRefinery.
 * Refreshes when the route changes (cheap count endpoint).
 * Hidden when there are zero flagged rows — the top bar stays clean for clean data.
 */
export function ReviewBadge() {
  const [count, setCount] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let active = true;
    api.get('/analytics/needs-review-count')
      .then(res => { if (active) setCount(res.data?.total || 0); })
      .catch(() => { if (active) setCount(0); });
    return () => { active = false; };
  }, [location.pathname]);

  if (!count) return null;

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => navigate('/review-queue')}
      className="h-8 gap-1.5"
      data-testid="review-badge"
      title="Open review queue"
    >
      <AlertCircle className="w-4 h-4 text-amber-500" />
      <Badge variant="secondary" className="bg-amber-100 dark:bg-amber-900/40 text-amber-800 dark:text-amber-200 border-0">
        {count.toLocaleString()} pending review
      </Badge>
    </Button>
  );
}
